import { render, staticRenderFns } from "./searchResults.vue?vue&type=template&id=c49b513a&scoped=true&"
import script from "./searchResults.vue?vue&type=script&lang=js&"
export * from "./searchResults.vue?vue&type=script&lang=js&"
import style0 from "./searchResults.vue?vue&type=style&index=0&id=c49b513a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49b513a",
  null
  
)

export default component.exports